import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Dashboard } from "./Dashboard";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "MESSAGE_ARCHIVE",
    applicationRights: Rights,
    title: 'Meldingsarkiv',
    text: 'Meldingsarkiv',
    icon: 'archive',
    showOnDashboardByDefault: false,
    url: "/message-archive",
    mobileThreshold: 1024,
    sequenceNo: 17500,
    routes: Routes,
    dashboard: Dashboard
})
